import React from 'react';
import { ARTICLES } from '../../data/smaken';
import { Reveal } from '../Reveal';
import { ArrowMark } from '../Marks';
const [lead, ...rest] = ARTICLES;
export function Magazine() {
  return <section aria-labelledby="magasin-rubrik" className="border-t border-black/12" data-id="element-477" data-mp="1kdla533q7vyq">
      <div className="mx-auto max-w-page px-5 py-16 md:px-8 md:py-24" data-id="element-478" data-mp="1fe8mwh8y0mvm">
        <Reveal data-id="element-479" data-mp="1fg1vw3713j6s">
          <div className="flex flex-wrap items-end justify-between gap-6 border-b-2 border-black pb-6" data-id="element-480" data-mp="1tdqef4dmie8o">
            <h2 id="magasin-rubrik" className="display-xl text-4xl uppercase sm:text-6xl" data-id="element-481" data-mp="1pcemutb6vixu">
              Från vårt Småland
            </h2>
            <p className="text-[11px] font-bold uppercase tracking-wide3 text-black/45" data-id="element-482" data-mp="2328chduiq78m">Läsning</p>
          </div>
        </Reveal>

        <div className="mt-12 grid gap-12 lg:grid-cols-[minmax(0,1.2fr),minmax(0,1fr)] lg:gap-16" data-id="element-483" data-mp="1y6jjjtd07ola">
          <Reveal data-id="element-484" data-mp="2czmtbekcsy1g">
            <article className="group cursor-pointer" data-id="element-485" data-mp="282mo15vbvzbe">
              <div className="aspect-[3/2] overflow-hidden bg-black/5" data-id="element-486" data-mp="2847g8ou67663">
                <img src={lead.image} alt={lead.title} className="h-full w-full object-cover transition-transform duration-[280ms] ease-out group-hover:scale-[1.03]" data-id="element-487" data-mp="1qqyggusmkyyy" />
              </div>
              <p className="mt-6 text-[11px] font-bold uppercase tracking-wide2 text-rod" data-id="element-488" data-mp="1zt7mb7cy8460">
                {lead.kicker} · {lead.readTime}
              </p>
              <h3 className="display-xl mt-3 text-3xl leading-tight sm:text-[2.6rem]" data-id="element-489" data-mp="29o9bu4b4z894">{lead.title}</h3>
              <p className="mt-4 max-w-xl text-lg leading-relaxed text-black/70" data-id="element-490" data-mp="2emucg4uavty3">{lead.excerpt}</p>
              <span className="mt-5 inline-flex items-center gap-2 border-b-2 border-black pb-1 text-[12px] font-bold uppercase tracking-wide2 transition-colors duration-150 ease-out group-hover:border-rod group-hover:text-rod" data-id="element-491" data-mp="2jg5aphl1r2ee">
                Läs
                <ArrowMark className="h-3.5 w-8" data-id="element-492" data-mp="2xemyffaycewb" />
              </span>
            </article>
          </Reveal>

          <div className="border-t border-black/15" data-id="element-493" data-mp="xbudww0p4q9d">
            {rest.map((article, i) => <Reveal key={article.slug} delay={Math.min(i * 0.06, 0.2)} data-id="element-494" data-mp="sdkickb27nn8" data-mpi={i}>
                <article className="group grid cursor-pointer grid-cols-[minmax(0,1fr),7rem] items-start gap-5 border-b border-black/15 py-6 sm:grid-cols-[minmax(0,1fr),9rem]" data-id="element-495" data-mp="sbg2r53st074">
                  <div data-id="element-496" data-mp="12a5mz4j62wqj">
                    <p className="text-[11px] font-bold uppercase tracking-wide2 text-rod" data-id="element-497" data-mp="129nlnthndsbr">
                      {article.kicker} · {article.readTime}
                    </p>
                    <h3 className="mt-2 font-display text-xl leading-snug transition-colors duration-150 ease-out group-hover:text-rod sm:text-2xl" data-id="element-498" data-mp="1c10bygnssafo">
                      {article.title}
                    </h3>
                    <p className="mt-2 text-sm leading-relaxed text-black/60" data-id="element-499" data-mp="1kzvk3yaejulm">{article.excerpt}</p>
                  </div>
                  <img src={article.image} alt="" loading="lazy" className="aspect-square w-full object-cover" data-id="element-500" data-mp="3mtkz6ebvz8k6" />
                </article>
              </Reveal>)}
          </div>
        </div>
      </div>
    </section>;
}